import { useSelector } from "react-redux";

import { UserDto } from "../../DTOs/User/UserDto";
import { RootState } from "../../state/store";

export const hasAnyRole = (user: UserDto | null, required: string | string[]): boolean => {
  if (!user) return false;

  const roles = Array.isArray(required) ? required : [required];
  const userRoles = user.roles.map(r => r.name);

  if (userRoles.map(x => (x || "").toLowerCase().replace(/\s+/g, '')).includes("superadmin")) return true;

  return roles.some(role => userRoles.includes(role));
};

export function hasAllRoles(user: UserDto | null, roles: string[]): boolean {
  if (!user) return false;
  if (roles.map(x => (x || "").toLowerCase().replace(/\s+/g, '')).includes("superadmin")) return true;
  return roles.every(role => user.roles.some(r => r.name === role));
}

export function hasRole(user: UserDto | null, role: string): boolean {
  if (!user) return false;
  return user.roles.some(r => r.name === role);
}

export function canEditModule(user: UserDto | null, module: string | undefined): boolean {
  if (!user || !module) return false;
  return user.editableModules.includes(module);
}

export function useIsViewOnly(modules: string | string[]): boolean {
  const user = useSelector((s: RootState) => s.authReducer.user);
  const list = Array.isArray(modules) ? modules : [modules];
  return !list.some(m => canEditModule(user, m));
}